import React from "react";
import { LPMUKP } from "./LPMUKP";
const Pegawai = React.lazy(() => import('./pegawai'));
const Produksi = React.lazy(() => import('./produksi'));
const Keuangan = React.lazy(() => import('./keuangan'));
const Valnas = React.lazy(() => import('./valnas'));
const Renja = React.lazy(() => import('./renja'));
const PHLN = React.lazy(() => import('./perencanaan/phln'));
const PHukum = React.lazy(() => import('./hukum/peraturanhukum'));
const RealDanRenKeu = React.lazy(()=>import('./RealisasiDanRencanaKeuangan'));
const TabContainer = React.lazy(()=>import('./TabContainer/index'));

export const dashPageConfig = [
    {
        path: '/dash/pegawai',
        element:<Pegawai/>
    },
    {
        path:'/dash/lpmukp',
        element:<LPMUKP />
    },
    {
        path: '/dash/produksi',
        element:<Produksi/>
    },
    {
        path: '/dash/keuangan',
        element:<Keuangan/>
    },
    {
        path: '/dash/valnas',
        element:<Valnas/>
    },
    {
        path: '/dash/renja',
        element:<Renja/>
    },
    {
        path: '/dash/phln',
        element:<PHLN/>
    },
    {
        path: '/dash/phukum',
        element:<PHukum/>
    },
    {
        path: '/dash/drealdanren',
        element:<RealDanRenKeu/>
    },
    {
        path: '/dash/tab/:type',
        element:<TabContainer/>
    }
];